import { IComponentType, IFaceLandmark } from '../component-data-structure';
import { FACE_LANDMARK_DATA } from './constants';
export const getFaceTrackingComponentIdsBySceneId = (sceneId, componentsById) => {
    const scene = componentsById[sceneId];
    const faceLandmarkGroups = scene.children.filter((componentId) => componentsById[componentId].type == IComponentType.FaceLandmarkGroup);
    return faceLandmarkGroups.reduce((acc, faceLandmarkGroupId) => {
        const faceLandmarkGroup = componentsById[faceLandmarkGroupId];
        return [...acc, ...faceLandmarkGroup.children];
    }, []);
};
export const uarTarget = (landmark, isFrontCamera) => {
    switch (landmark) {
        case IFaceLandmark.earLeft:
            return isFrontCamera ? 'ear-right' : 'ear-left';
        case IFaceLandmark.earRight:
            return isFrontCamera ? 'ear-left' : 'ear-right';
        case IFaceLandmark.eyeLeft:
            return isFrontCamera ? 'eye-right' : 'eye-left';
        case IFaceLandmark.eyeRight:
            return isFrontCamera ? 'eye-left' : 'eye-right';
        case IFaceLandmark.eyebrowLeft:
            return isFrontCamera ? 'eyebrow-right' : 'eyebrow-left';
        case IFaceLandmark.eyebrowRight:
            return isFrontCamera ? 'eyebrow-left' : 'eyebrow-right';
        case IFaceLandmark.chin:
            return 'chin';
        case IFaceLandmark.lipTop:
            return 'lip-top';
        case IFaceLandmark.lipBottom:
            return 'lip-bottom';
        case IFaceLandmark.noseBase:
            return 'nose-base';
        case IFaceLandmark.noseBridge:
            return 'nose-bridge';
        case IFaceLandmark.noseTip:
            return 'nose-tip';
        default:
            return 'origin';
    }
};
export const getFaceLandmarkPositionsByHeadbustType = (bustType) => {
    return Object.keys(FACE_LANDMARK_DATA[bustType]).reduce((acc, landmark) => {
        acc[landmark] = FACE_LANDMARK_DATA[bustType][landmark].position;
        return acc;
    }, {});
};
